var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanderaCheck34X34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4284 22.2644C29.8773 22.6423 29.9349 23.3126 29.5571 23.7615L23.3804 31.0999C23.1935 31.3219 22.9239 31.4578 22.6343 31.4761C22.3446 31.4943 22.0601 31.3932 21.8469 31.1964L18.3477 27.9664C17.9165 27.5684 17.8896 26.8962 18.2876 26.465C18.6856 26.0338 19.3578 26.0069 19.789 26.4049L22.4709 28.8805L27.9313 22.3931C28.3092 21.9442 28.9795 21.8866 29.4284 22.2644Z",
    fill: "#3677DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23669 2.52148C9.82349 2.52148 10.2992 2.99718 10.2992 3.58398V30.4157C10.2992 31.0025 9.82349 31.4782 9.23669 31.4782C8.64989 31.4782 8.17419 31.0025 8.17419 30.4157V3.58398C8.17419 2.99718 8.64989 2.52148 9.23669 2.52148Z",
    fill: "#3677DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19336 30.4157C4.19336 29.8288 4.66906 29.3532 5.25586 29.3532H13.1892C13.776 29.3532 14.2517 29.8288 14.2517 30.4157C14.2517 31.0025 13.776 31.4782 13.1892 31.4782H5.25586C4.66906 31.4782 4.19336 31.0025 4.19336 30.4157Z",
    fill: "#3677DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17419 6.58732C8.17419 6.00052 8.64989 5.52482 9.23669 5.52482H27.285C27.6903 5.52482 28.0603 5.7554 28.2389 6.11924C28.4174 6.48309 28.3734 6.91683 28.1254 7.23741L24.3216 12.1548L28.1254 17.0722C28.3734 17.3928 28.4174 17.8265 28.2389 18.1904C28.0603 18.5542 27.6903 18.7848 27.285 18.7848H9.23669C8.64989 18.7848 8.17419 18.3091 8.17419 17.7223V6.58732ZM10.2992 7.64982V16.6598H25.1199L22.1379 12.8049C21.8418 12.4221 21.8418 11.8875 22.1379 11.5047L25.1199 7.64982H10.2992Z",
    fill: "#3677DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanderaCheck34X34);
export default __webpack_public_path__ + "static/media/BANDERA_CHECK_34X34.0a1593287ed68f4fd91844dcfe4dddf4.svg";
export { ForwardRef as ReactComponent };